// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"e1551250","277":"08507676","455":"6cd4e91a","457":"eded04df","845":"32e3f1ec","895":"bfc8ad3a","977":"ccc7c5de"}[chunkId] + ".chunk.js";
};